import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  header: {
    marginBottom: theme.spacing(4),
    fontSize: 16,
    [theme.breakpoints.up('mobile')]: {
      fontSize: 24,
    },
  },
  switchBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: theme.spacing(3),
    borderBottom: [1, 'dotted', theme.palette.colors.border],
  },
  stateItem: {
    width: '100%',
    display: 'flex',
    marginTop: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  stateName: {
    width: 100,
    [theme.breakpoints.up('mobile')]: {
      width: 120,
    },
  },
  button: {
    '&.MuiButton-contained': {
      fontWeight: 400,
    },
    marginLeft: theme.spacing(2),
    borderRadius: 22,
    height: 40,
  },
  disabledButton: {
    '&.MuiButton-containedPrimary': {
      color: theme.palette.colors.teal,
      backgroundColor: theme.palette.colors.lightTeal,
    },
    '&.MuiButton-contained.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
      backgroundColor: 'rgba(0, 0, 0, 0.12)',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/SubscriptionPage/components/Connections/useStyles.js